/**
 * Trigger a browser download for a Blob. DOM side effect; deliberately kept
 * out of the domain; the saga invokes it via `call(...)` per planned download
 * (kept 1:1 with the original useProfileExport helper).
 */
export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
